import {registerTemplateGraphNode} from "#template/template-node/register"
import {meshGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {MeshGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {TriangulateOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/triangulate-operator/geometry-triangulate-operator-node"
import {
    GeometryTriangulateOperatorNode,
    triangulateOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/triangulate-operator/geometry-triangulate-operator-node"

const definition: TemplateNodeDefinition<TriangulateOperatorParameters> = {
    nodeClass: "MeshGeometryTriangulateOperator",
    validation: {
        parameters: triangulateOperatorParametersSchema,
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class MeshGeometryTriangulateOperator extends GeometryTriangulateOperatorNode implements MeshGeometryAttributeSetLikeNode {
    get [meshGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
